import { useState, type FormEvent } from 'react';
import * as A from '../api/planning.ts';
import { Banner } from '../ui/bits.tsx';

/**
 * The login screen.
 *
 * THE ERROR TEXT COMES FROM THE SERVER AND IS NOT ELABORATED. The backend deliberately gives one
 * answer for wrong-password, no-such-user, revoked-binding and disabled-actor; adding a helpful
 * "controleer je gebruikersnaam" here would hand back the distinction the backend just refused to make.
 */
export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await A.login(username, password);
      onSignedIn();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="card stack" onSubmit={submit}>
        <h1 style={{ margin: 0, fontSize: 20 }}>Bruce Planning</h1>
        <p className="faint" style={{ marginTop: -8 }}>Meld je aan om de planning te openen.</p>
        {error && <Banner kind="err">{error}</Banner>}
        <div className="field">
          <label htmlFor="u">Gebruikersnaam of e-mail</label>
          <input id="u" value={username} onChange={(e) => setUsername(e.target.value)}
                 autoComplete="username" autoCapitalize="none" autoCorrect="off" required />
        </div>
        <div className="field">
          <label htmlFor="p">Wachtwoord</label>
          <input id="p" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                 autoComplete="current-password" required />
        </div>
        <button className="btn primary" type="submit" disabled={busy || !username || !password}>
          {busy ? 'Bezig…' : 'Aanmelden'}
        </button>
        {/* GOOGLE IS HIDDEN UNTIL IT IS CONFIGURED. A button that always fails is worse than no button;
            it appears once the backend reports the provider as available. */}
        <p className="faint">
          Google Workspace-login wordt toegevoegd zodra de OAuth-client is aangemaakt.
        </p>
      </form>
    </div>
  );
}
